import styled from 'styled-components';
import { COLORS } from 'styles/variables';

export const InformationSalesReportWrapper = styled.div`
  margin: 5rem 0 10rem;
  border: 1px solid ${COLORS.GREY_4};
  background-color: ${COLORS.WHITE};
`;
